(function(){
  'use strict';
  function init(){
    if(location.pathname!=='/') return;
    var root=document.getElementById('KlaxonHome');
    if(!root) return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets=root.querySelectorAll('[data-klx-reveal]');
    if(reduce||!('IntersectionObserver' in window)){
      targets.forEach(function(el){el.classList.add('is-visible');});
      return;
    }
    document.documentElement.classList.add('js-klx-reveal');
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}
      });
    },{threshold:.12,rootMargin:'0px 0px -36px 0px'});
    targets.forEach(function(el){observer.observe(el);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
